<template>
  <div>
    <SiteHeader bg="false"></SiteHeader>
    <CISynchronizerSupport />
    <SiteFooter></SiteFooter>
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue';
import CISynchronizerSupport from '@/components/CISynchronizerSupport.vue';
import SiteFooter from '@/components/Footer.vue';
export default {
  name: 'Home',
  components: {
    SiteHeader,
    SiteFooter,
    CISynchronizerSupport
  },
  props: []
};
</script>

<style lang="scss"></style>
